//在此处编写调用授权等基本平台接口
import store from '@/store/'
class osrd_api {
  constructor(axiosFactory) {
    this.$http = axiosFactory;
  }
  http() {
    return this.$http;
  };
  get(url, cb) {
    this.$http.get(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  gets(url, data, cb) {
    this.$http.get(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  post(url, data, cb) {
    this.$http.post(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  posts(url, cb) {
    this.$http.post(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  put(url, data, cb) {
    this.$http.put(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  puts(url, cb) {
    this.$http.put(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  delete(url, data, cb) {
    this.$http.delete(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  deletes(url, cb) {
    this.$http.delete(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }

  //------------------------------------------------------------
  //推荐职位
  getRecommendPosition(pageNum,pageSize,cb){
    // debugger
    this.get(`/recommend/my/positions?pageNum=${pageNum}&pageSize=${pageSize}`,cb)
  }
  //推荐猎头
  getRecommendHunter(size,cb){
    // this.get(`/recommend/applicant/hunterRecommend?&size=${size}`,cb)
    this.get(`/recommend/my/hunters?&size=${size}`,cb)
  }
  //推荐公司
  getRecommendEnterprise(size,cb){
    // debugger
    this.get(`/recommend/my/enterprises?size=${size}`,cb)
  }






}
class apiFactory {
  constructor() {

  }
  createApi(axios) {
    return new osrd_api(axios)
  }
}
export default new apiFactory();
